export default "__VITE_ASSET__C$JIl2Xh__"